/* eslint-disable @typescript-eslint/no-explicit-any */
import {defaultValues} from '../../data/constants/Assurance/assuranceRetraite';
import {IError} from '../../data/types/interface/Assurance/assuranceRetraite';
import {MAIL_VALIDATION, MESSAGE_VALIDATION} from './validation';

export const Validation = (values: IError, listAgence?: []) => {
  let errors: IError = {...defaultValues};

  /** mail checking */

  if (!MAIL_VALIDATION.test(values.emailAssure)) {
    errors.emailAssure = MESSAGE_VALIDATION.requiredEmail;
  }

  /** agence cheking */

  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values.agence.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.invalidAgence;
    }
  }

  /** telphone cheking */

  if (!/^0\d{9}$/g.test(values.telephoneContractant)) {
    errors.telephoneContractant = MESSAGE_VALIDATION.requiredTelephone;
  }

  /** telphone cheking */

  if (!/^0\d{9}$/g.test(values.telephoneAssure)) {
    errors.telephoneAssure = MESSAGE_VALIDATION.requiredTelephone;
  }
  if (parseInt(values.premierVersement.replace(/[^0-9]/g, '')) < 2000) {
    errors.premierVersement = 'Le montant minimum est de 2 000Ar';
  }

  /** date de naissance checking */

  if (values.dateNaissanceContractant !== '') {
    const _ageMin = 21;
    const _date = new Date(values.dateNaissanceContractant);
    const minDate = new Date();
    minDate.setFullYear(new Date().getFullYear() - _ageMin);
    if (_date >= minDate) {
      errors.dateNaissanceContractant = `L'âge minimum valide est de ${_ageMin} ans`;
    }
  }

  if (values.dateNaissanceAssure !== '') {
    const _ageMin = 18;
    const _date = new Date(values.dateNaissanceAssure);
    const minDate = new Date();
    minDate.setFullYear(new Date().getFullYear() - _ageMin);
    if (_date >= minDate) {
      errors.dateNaissanceAssure = `L'âge minimum valide est de ${_ageMin} ans`;
    }
  }

  if (values.cinAssure === 'INVALID INPUT') {
    errors.cinAssure = MESSAGE_VALIDATION.invalidImageFormat;
  } else {
    if (values.cinAssure.length < 1) {
      errors.cinAssure = MESSAGE_VALIDATION.requiredCin;
    } else {
      errors.cinAssure = '';
    }
  }

  if (values.cinContractant === 'INVALID INPUT') {
    errors.cinContractant = MESSAGE_VALIDATION.invalidImageFormat;
  } else {
    if (values.cinContractant.length < 1) {
      errors.cinContractant = MESSAGE_VALIDATION.requiredCin;
    } else {
      errors.cinContractant = '';
    }
  }

  {
    /** checking all values */
  }
  Object.entries(values).forEach(element => {
    if (
      element[0] !== 'telephoneContractantCountryCode' &&
      (element[1] === '' ||
        element[1] === null ||
        (Array.isArray(element[1]) && element[1].length === 0) ||
        element[1] === ' ')
    ) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
